var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.385 7.622c.34 0 .618.28.618.625v4.139a.622.622 0 01-.618.626.622.622 0 01-.618-.626V8.247c0-.345.276-.625.618-.625zm2.537 0c.341 0 .618.28.618.625v4.139a.622.622 0 01-.618.626.622.622 0 01-.618-.626V8.247c0-.345.277-.625.618-.625zm2.673 0c.341 0 .618.28.618.625v4.139a.622.622 0 01-.618.626.622.622 0 01-.618-.626V8.247c0-.345.276-.625.618-.625z",
    fill: "#41422C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.972 3.621C5.205 2.112 6.49 1 7.998 1c1.52 0 2.81 1.128 3.03 2.65l.24 1.654h1.63c1.288 0 2.273 1.161 2.077 2.45l-.823 5.43-.005.022c-.24 1.066-1.204 1.792-2.281 1.793L4.086 15c-1.078 0-2.043-.727-2.282-1.792l-.006-.025-.776-5.449c-.183-1.282.8-2.43 2.08-2.43h1.61l.26-1.683zm.992 1.683h4.055l-.214-1.473a1.833 1.833 0 00-1.807-1.58c-.9 0-1.666.663-1.804 1.563l-.23 1.49zM3.102 6.555a.872.872 0 00-.857 1l.769 5.397c.111.447.54.797 1.071.797l7.78-.001c.533 0 .962-.352 1.072-.8l.817-5.385a.872.872 0 00-.856-1.008H3.102z",
    fill: "#41422C"
  })));
}
export default SvgBasket;